export enum AutoConnectCameraStatus {
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  FAILED = 'failed',
}

export enum CameraType {
  SMALL = 'small',
}
